import { render, staticRenderFns } from "./PuzzleFencesList.vue?vue&type=template&id=0b50c053&"
import script from "./PuzzleFencesList.vue?vue&type=script&lang=js&"
export * from "./PuzzleFencesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports